import { useState } from "react";
import axios from "axios";
import { useLocalStorage } from "./useLocalStorage";

const useGetMovie = (url) => {
  const [movie, setMovie] = useLocalStorage("movie", "");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  async function getMovie() {
    try {
      const response = await axios.get(url);
      const result = response.data;
      setMovie(result);
      setLoading(false);
      setError(false);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  }
  return { movie, loading, error, getMovie };
};

export default useGetMovie;
